import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import ProjectMilestonesForm from "../../../pages/admin/project/project-details/components/ProjectMilestonesForm";
import CreateApplication from "../../../pages/admin/collaboration-agreement/details/components/beneficiary/create";
import VerifyDocDrawer from "../../../pages/admin/collaboration-agreement/details/components/beneficiary/benificiaries-details/details-components/drawers/VerifyDocDrawer";
import AddDisbursmentDrawer from "../../../pages/admin/collaboration-agreement/details/components/beneficiary/benificiaries-details/details-components/drawers/AddDisbursmentDrawer";
import AddUtilizationDrawer from "../../../pages/admin/collaboration-agreement/details/components/beneficiary/benificiaries-details/details-components/drawers/AddUtilizationDrawer";


const ProjectMilestoneForm: React.FC = () => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>
            {drawer.name === 'Add Milestones' && <ProjectMilestonesForm />}
            {drawer._Key === 'BeneficiaryDrawer' && <CreateApplication />}
            {drawer._Key === 'VerifyDocDrawer' && <VerifyDocDrawer />}
            {drawer._Key === 'AddDisbursmentDrawer' && <AddDisbursmentDrawer />}
            {drawer._Key === 'AddUtilizationDrawer' && <AddUtilizationDrawer />}
        </Box>
    )
}

export default ProjectMilestoneForm